class UserInfo {
  constructor(data = {}) {
    this.name = data.name || "User Name";
    this.location = data.location || "User Location";
    this.email = data.email || "User Email";
    this.startDate = data.startDate|| "User Start Data"
    this.lastLogin = data.lastLogin || "User Last Login"
  }

  get name() {
    return this._name;
  }

  get location() {
    return this._location;
  }

  get email() {
    return this._email;
  }

  get startDate() {
    return this._startDate;
  }

  get lastLogin() {
    return this._lastLogin;
  }

  set name(value) {
    this._name = value;
  }

  set location(value) {
    this._location = value;
  }

  set email(value) {
    this._email = value;
  }

  set startDate(value) {
    this._startDate = value;
  }

  set lastLogin(value) {
    this._lastLogin = value;
  }
}

export default UserInfo;